export default import.meta.ROLLDOWN_FILE_URL_F9h4qF7OyxePqfaW7sPkYA